import Vue from 'vue'
import Vuex from 'vuex'
import { appbar } from './appbar'
import { user } from './user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pageTitle: 'wordprison-web',
    actionMode: false,
    assistantHeaderHeight: 0,
    topMargin: 0,
    // 當前頁面的 key
    currentPage: null
  },
  mutations: {
    enableActionMode(state){
      state.actionMode = true
      console.log('enableActionMode')
    },
    setPageTitle(state, title){
      state.pageTitle = title
      let elementTitle = document.head.querySelector('title')
      if(elementTitle){
        elementTitle.innerHTML = title
      }
    },
    setAssistantHeaderHeight(state, height){
      state.assistantHeaderHeight = height
      console.log('setAssistantHeaderHeight', height)
    },
    updateTopMargin(state){
      state.topMargin = state.assistantHeaderHeight + 48
      console.log('updateTopMargin', state.topMargin)
    }
  },
  actions: {
  },
  modules: {
    appbar,
    user
  }
})
